import { ButtonProps } from "@mui/material";
import colors from "theme/base/colors";
import VidletButton from "./VidletButton";

export default function AddButton({ children, sx, ...props }: ButtonProps) {
  return (
    <VidletButton
      sx={{
        borderRadius: "2rem",
        height: "2.5rem",
        backgroundColor: colors.grey[800],
        "&:hover": {
          backgroundColor: colors.primary.light,
        },
        ...sx,
      }}
      {...props}
    >
      {children || "ADD"}
    </VidletButton>
  );
}
